/**
 * Inline worker source (data URL). Protocol:
 * - `set_time_out` { timeout, warningTime } — clears any prior interval, starts countdown.
 * - `clear_timer` — stops the interval.
 */
const countDownWorkerScript = `data:application/javascript,
let countdownTimer = null;
let remainingMs = 0;
let warningMs = 0;
function clearCountdownTimer() {
  if (countdownTimer != null) {
    clearInterval(countdownTimer);
    countdownTimer = null;
  }
}
onmessage = function (e) {
  switch (e.data.message) {
    case 'set_time_out':
      clearCountdownTimer();
      remainingMs = e.data.payload.timeout;
      warningMs = e.data.payload.warningTime;
      countdownTimer = setInterval(function () {
        remainingMs -= 1000;
        if (remainingMs <= warningMs) {
          postMessage({
            message: 'set_count_down',
            payload: { value: Math.max(0, remainingMs) }
          });
        }
        if (remainingMs <= 0) {
          clearCountdownTimer();
          postMessage({
            message: 'set_count_down',
            payload: { value: 0 }
          });
          postMessage({
            message: 'set_inactive',
            payload: { value: true }
          });
        }
      }, 1000);
      break;
    case 'clear_timer':
      clearCountdownTimer();
      break;
  }
};
`;

export default countDownWorkerScript;
